import React from 'react';
import { Box, Container, Typography, Button, Grid, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';  // Add this import
import FlyerSlideshow from './FlyerSlideshow';


const Home = () => {
  const { t } = useTranslation();  // Add translation hook

  return (
    <>
      <Box
        sx={{
          background: theme => theme.palette.background.gradient,
          minHeight: '30vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
       
        <Container>
          <Grid container spacing={4} alignItems="center">
            {/*<Grid item xs={12} md={3}>
              <Box sx={{ mb: 1 }}>
                <img 
                  src="/images/logo.png" 
                  alt="Zen Life Acupuncture" 
                  style={{ maxWidth: '100%', height: 'auto', maxHeight: '480px' }} 
                />
              </Box>
            </Grid> */}
            <Grid item xs={12} md={12}>
              <Box sx={{ mb: 1 }}>
                <Typography variant="h4" gutterBottom>
                  {t('home.welcome')}
                </Typography>
                <Typography variant="h5" gutterBottom>
                  {t('home.subtitle')}
                </Typography>
                <Typography variant="body1" paragraph>
                  {t('home.description1')}
                </Typography>
                <Typography variant="body1" paragraph>
                  {t('home.description2')}
                </Typography>
                <Typography variant="body1" paragraph>
                  {t('home.description3')}
                </Typography>
                <Typography variant="body1" paragraph>
                  {t('home.description4')}
                </Typography>
              
                
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Button
                      component={Link}
                      to="/booking"
                      variant="contained"
                      size="large"
                      fullWidth
                    >
                      {t('home.bookButton')}
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      component={Link}
                      to="/contact"
                      variant="contained"
                      size="large"
                      fullWidth
                    >
                      {t('home.contactButton')}
                    </Button>
                  </Grid>
                </Grid>
              </Box>



              <Typography variant="h5" gutterBottom>
                  {t('home.subtitleinsurance')}
                </Typography>
                <Typography variant="body1" paragraph>
                  {t('home.insuranceprompt')}
                </Typography>
            </Grid>
          </Grid>
        </Container>


        <Container sx={{ py: 4 }}>
        <Typography variant="h4" align="center" gutterBottom>
          {t('home.videoTitle', 'Free Tea Every Sunday!')}
        </Typography>
        <Typography variant="body1" paragraph>
                  {t('home.videoDescription')}
        </Typography>
        
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          my: 3,
          position: 'relative',
          paddingBottom: '56.25%', /* 16:9 aspect ratio */
          height: 0,
          overflow: 'hidden',
          maxWidth: '100%',
          width: '100%',
        }}>
          <iframe
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
            src="https://www.youtube.com/embed/fahmSFHBcyU"
            title="Zen Life Acupuncture Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </Box>
      </Container>

      </Box>

      <Container sx={{ py: 8 }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h3" align="center" gutterBottom>
              {t('services.title')}
            </Typography>
          </Grid>
          {[
            'acupuncture',
            'electroacupuncture',
            'cupping',
            'guaSha',
            'manualTherapy',
            'infraLight',
            'herbs'
          ].map((serviceKey) => (
            <Grid item xs={12} sm={6} md={4} key={serviceKey}>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: '0.3s',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                  },
                }}
              >
                <Typography variant="h5" gutterBottom>
                  {t(`services.${serviceKey}.title`)}
                </Typography>
                <Typography variant="body1">
                  {t(`services.${serviceKey}.description`)}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>

      <Container sx={{ py: 4 }}>
        <Typography variant="h4" align="center" gutterBottom>
          {t('home.promotions', 'Special Promotions')}
        </Typography>
        <FlyerSlideshow />
      </Container>
    </>
  );
};

export default Home;